let productCardMarkup = `
  <h6 style="text-align:center;"><span id='total_products'></span></h6>
  <ul class="swym-container">
    {{#products}}
    <li>
      <div class="grid-view-item product-card">
        <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
          <img  class="grid-view-item__image lazyautosizes" src="{{iu}}" width="326px" height="326px"/>
        </div>

        <div class="swym-product-info">
          <div class="swym-product-title" aria-hidden="true">{{dt}}</div>
          <div class="swym-vendor-name" aria-hidden="true">{{bt}}</div>
          <dl class="price" data-price="">
            <span class="price-item price-item--sale" data-sale-price="">
              {{cu}}{{pr}}
            </span>
          </dl>
          <div class="swym-action-buttons-container">
            <a href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="btn product__submit__add add-to-cart">
              {{#isInCart}}ADD TO CART{{/isInCart}}
              {{^isInCart}}ADD TO CART{{/isInCart}}
            </a>

            <a id="swym-remove-productBtn" href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="btn product__remove remove-from-cart">
              REMOVE
            </a>
          </div>
        </div>
      </div>
    </li>
    {{/products}}
  </ul>
`;

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function swymCallbackFn() {
  // gets called once Swym is ready
  let wishlistContentsContainer = document.getElementById(
    "wishlist-items-container"
  );
  _swat.fetchWrtEventTypeET(
    function (products) {
      // Get wishlist items
      let formattedWishlistedProducts = products.map(function (product) {
        product = SwymUtils.formatProductPrice(product); // formats product price and adds currency to product Object
        product.isInCart =
          _swat.platform.isInDeviceCart(product.epi) ||
          product.et == _swat.EventTypes.addToCart;
        product.variantinfo = product.variants
          ? getVariantInfo(product.variants)
          : "";
        return product;
      });

      let productCardsMarkup = SwymUtils.renderTemplateString(
        productCardMarkup,
        {
          products: formattedWishlistedProducts,
        }
      );
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      // total products
      if (products.length > 1) {
        document.getElementById("total_products").innerHTML =
          products.length + " Pieces";
      } else {
        document.getElementById("total_products").innerHTML =
          products.length + " Piece";
      }

      attachClickListeners();
      attachClickListeners_remove();
    },
    window._swat.EventTypes.addToWishList,
    window._swat.EventTypes.removeFromWishList
  );
}

function onAddToCartClick(e) {
  e.preventDefault();
  let productId = e.target.getAttribute("data-product-id");
  let variantId = e.target.getAttribute("data-variant-id");
  let du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
    { empi: productId, du: du },
    variantId,
    function () {
      e.target.innerHTML = "Added to cart";
      window.location.reload();
      console.log("Successfully added product to cart.");
    },
    function (e) {
      console.log(e);
    }
  );
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
    window.location.reload();
  });
}

function attachClickListeners() {
  let addToCartButtons = Array.from(
    document.getElementsByClassName("add-to-cart")
  );
  let removeBtns = document.querySelectorAll("#swym-remove-productBtn");

  //   Add to cart Btn
  addToCartButtons.forEach((addToCartButton) => {
    addToCartButton.addEventListener("click", onAddToCartClick, false);
  });

  //   Remove Buttons
  removeBtns.forEach((removeBtn) => {
    removeBtn.addEventListener("click", onRemoveBtnClick, false);
  });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
